import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24;
let invoiceStyleModel = (_dec = attr('string'), _dec2 = hasMany('file', {
  inverse: null,
  async: true
}), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('boolean'), _dec7 = attr('string'), _dec8 = attr('boolean'), _dec9 = attr('string'), _dec0 = attr('boolean'), _dec1 = attr('string'), _dec10 = attr('string'), _dec11 = attr('boolean'), _dec12 = attr('boolean'), _dec13 = attr('boolean'), _dec14 = attr('boolean'), _dec15 = attr('boolean'), _dec16 = attr('string'), _dec17 = attr('string'), _dec18 = attr('string'), _dec19 = attr('number'), _dec20 = attr('number'), _dec21 = attr('boolean'), _dec22 = attr('boolean'), _dec23 = attr('string'), _dec24 = attr('boolean', {
  defaultValue: false
}), _class = class invoiceStyleModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "files", _descriptor2, this);
    _initializerDefineProperty(this, "background_color", _descriptor3, this);
    _initializerDefineProperty(this, "primary_color", _descriptor4, this);
    _initializerDefineProperty(this, "text_color", _descriptor5, this);
    _initializerDefineProperty(this, "show_logo", _descriptor6, this);
    _initializerDefineProperty(this, "logo_position", _descriptor7, this);
    _initializerDefineProperty(this, "show_society_name", _descriptor8, this);
    _initializerDefineProperty(this, "society_description", _descriptor9, this);
    _initializerDefineProperty(this, "show_society", _descriptor0, this);
    _initializerDefineProperty(this, "society_position", _descriptor1, this);
    _initializerDefineProperty(this, "contact_position", _descriptor10, this);
    _initializerDefineProperty(this, "show_qta", _descriptor11, this);
    _initializerDefineProperty(this, "show_unit", _descriptor12, this);
    _initializerDefineProperty(this, "show_price", _descriptor13, this);
    _initializerDefineProperty(this, "show_sign", _descriptor14, this);
    _initializerDefineProperty(this, "show_footer", _descriptor15, this);
    _initializerDefineProperty(this, "style", _descriptor16, this);
    _initializerDefineProperty(this, "footer_content", _descriptor17, this);
    _initializerDefineProperty(this, "notes", _descriptor18, this);
    _initializerDefineProperty(this, "header_height", _descriptor19, this);
    _initializerDefineProperty(this, "footer_height", _descriptor20, this);
    _initializerDefineProperty(this, "is_default", _descriptor21, this);
    _initializerDefineProperty(this, "is_editable", _descriptor22, this);
    _initializerDefineProperty(this, "custom_css", _descriptor23, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor24, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "background_color", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "primary_color", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "text_color", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "show_logo", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "logo_position", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "show_society_name", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "society_description", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "show_society", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "society_position", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "contact_position", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "show_qta", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "show_unit", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "show_price", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "show_sign", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "show_footer", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "style", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "footer_content", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "header_height", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "footer_height", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "is_default", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "is_editable", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "custom_css", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { invoiceStyleModel as default };
//# sourceMappingURL=invoice-style.js.map
